import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { Col, Row } from 'reactstrap';
import Select from 'react-select';
import forms from 'constants/forms';
import common from 'constants/common';
import AutoCompleteCareAgent from 'components/atoms/autocomplete';
import AutoCompleteClinic from 'components/molecules/autocompleteFilter/clinic';
import { API_ADMIN_PANEL_AGENCY_DOCTORS } from 'services/dataService/resources';
import useUser from 'utils/useUser';
import { isPractice } from 'utils/userTypeHelper';

const DEFAULT_STATUS = forms.ccmInteractionStatuses[0];
const DEFAULT_PATIENT_FILTER = forms.patientFilterOptions[0];
const DEFAULT_CLINIC_FILTER = forms.clinicFilterOptions[0];

const selectStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: '52px',
  }),
};

const Sorting = ({ setFilters, filters, timeRanges }) => {
  const { userType } = useUser();
  const [dateValue, setDateValue] = useState(timeRanges[0]);

  const selectTheme = (theme) => ({
    ...theme,
    borderRadius: 12,
    colors: {
      ...theme.colors,
      ...common.primaryColors,
    },
  });

  const statusValue = (statusName) => {
    const value = forms.statusSelect.find(
      (element) => element.value === statusName,
    );
    return value;
  };

  const ccmInteractionStatusChanged = async ({ value }) =>
    setFilters({ ccmInteractionStatus: value });

  const onDateChange = (value) => {
    setDateValue(value);
    setFilters({
      ...filters,
      billingYear: value.value[0],
      billingMonth: value.value[1],
    });
  };

  return (
    <Row>
      <Col xl="2" lg="2" md="2" sm="6" xs="12">
        <p className="mb-1">Report Time Window</p>
        <Select
          options={timeRanges}
          defaultValue={timeRanges[0]}
          value={dateValue}
          theme={(theme) => selectTheme(theme)}
          classNamePrefix="select-type"
          styles={selectStyles}
          onChange={onDateChange}
        />
      </Col>
      <Col xl="2" lg="2" md="2" sm="6" xs="12">
        <p className="mb-1">CCM Interaction Status</p>
        <Select
          options={forms.ccmInteractionStatuses}
          defaultValue={DEFAULT_STATUS}
          theme={(theme) => selectTheme(theme)}
          classNamePrefix="select-type"
          styles={selectStyles}
          value={statusValue(filters.ccmInteractionStatus)}
          onChange={ccmInteractionStatusChanged}
        />
      </Col>
      {!isPractice(userType) && (
        <>
          <Col xl="2" lg="2" md="2" sm="6" xs="12">
            <p>CCM Admission Agent</p>
            <AutoCompleteCareAgent
              filter={DEFAULT_PATIENT_FILTER}
              handleClick={({ value }) => {
                setFilters({ ccmAdmissionAgentGuid: value });
              }}
              getApi={(queryString) =>
                `${API_ADMIN_PANEL_AGENCY_DOCTORS}?fullName=${queryString}&roleName=ccm-`
              }
              dataCy="ccm-activity-header__care-agent-filter"
            />
          </Col>
          <Col xl="2" lg="2" md="2" sm="6" xs="12">
            <p>CCM Case Manager</p>
            <AutoCompleteCareAgent
              filter={DEFAULT_PATIENT_FILTER}
              handleClick={({ value }) => {
                setFilters({ ccmCaseManagerGuid: value });
              }}
              getApi={(queryString) =>
                `${API_ADMIN_PANEL_AGENCY_DOCTORS}?fullName=${queryString}&roleName=ccm-`
              }
              dataCy="ccm-activity-header__care-agent-filter"
            />
          </Col>
          <Col xl="2" lg="2" md="2" sm="6" xs="12">
            <p>CCM PAT Agent</p>
            <AutoCompleteCareAgent
              filter={DEFAULT_PATIENT_FILTER}
              handleClick={({ value }) => {
                setFilters({ ccmPatManagerGuid: value });
              }}
              getApi={(queryString) =>
                `${API_ADMIN_PANEL_AGENCY_DOCTORS}?fullName=${queryString}&roleName=ccm-`
              }
              dataCy="ccm-activity-header__care-agent-filter"
            />
          </Col>
        </>
      )}

      <Col xl="2" lg="2" md="2" sm="6" xs="12">
        <p>Clinic</p>
        <AutoCompleteClinic
          filter={DEFAULT_CLINIC_FILTER}
          handleClick={({ value }) => {
            setFilters({ clinicGuid: value });
          }}
        />
      </Col>
    </Row>
  );
};

Sorting.propTypes = {
  setFilters: PropTypes.func.isRequired,
  filters: PropTypes.object,
  timeRanges: PropTypes.array.isRequired,
};

export default Sorting;
